import _implicitStylesheets from "./socialImpact.css";
import _implicitScopedStylesheets from "./socialImpact.scoped.css?scoped=true";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import _wdsMediaCard from "wds/mediaCard";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h3 type-style="display-6" class="section-heading${0}"${2}>${"t1"}</h3>`;
const stc0 = {
  classMap: {
    "section-heading-container": true
  },
  key: 0
};
const stc1 = {
  "tooltip-container": true
};
const stc2 = {
  classMap: {
    "card-grid": true
  },
  key: 4
};
const stc3 = {
  "card-grid__item": true
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, k: api_key, b: api_bind, i: api_iterator} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.heading))]), $cmp.showSocialImpactTooltip ? api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    classMap: stc1,
    props: {
      "titledSections": $cmp.socialImpactTooltipSections,
      "popoverOrientation": $cmp.socialImpactTooltipOrientation
    },
    key: 3
  }) : null]), api_element("div", stc2, api_iterator($cmp.socialImpactCards, function (card) {
    return api_element("div", {
      classMap: stc3,
      attrs: {
        "data-feature": card.key
      },
      key: api_key(5, card.key),
      on: {
        "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleCardAnalytics))
      }
    }, [api_custom_element("wds-media-card", _wdsMediaCard, {
      props: {
        "category": card.category,
        "title": card.title,
        "image": card.image,
        "callToAction": card.callToAction,
        "ctaAriaLabel": card.ctaAriaLabel,
        "isExternalCta": card.isExternalCta
      },
      key: 6
    })]);
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6t868un2f6t";
tmpl.legacyStylesheetToken = "undefined-_socialImpact";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
